import LogsPageAI from "../../components/policyEngine/logspage-ai";
import TroubleshootReport from "../../components/policyEngine/TroubleshootReport";
import PAMEndpoint from "../../components/privilegedAccessManagement/endpoints/Endpoints";
import EndpointDetails from "../../components/privilegedAccessManagement/endpoints/EndpointDetails";
import PasswordPolicies from "../../components/privilegedAccessManagement/endpoints/PasswordPolicies";
import Jumpserver from "../../components/privilegedAccessManagement/jumpServers/Jumpserver";
import SshProxyOnboarding from "../../pages/enduser/ssh-proxy/SshProxyOnboarding";
import GatewayDetail from "../../pages/enduser/ssh-proxy/gateway/GatewayDetail";
import SessionRecordings from "../../components/privilegedAccessManagement/sessionRecordings/SessionRecordings";
import RecordingPlayerPage from "../../components/privilegedAccessManagement/sessionRecordings/RecordingPlayerPage";
import EnrolTokensPage from "../../pages/enduser/ssh-proxy/enrol/EnrolTokensPage";
import AgentLogs from "../../components/privilegedAccessManagement/endpoints/AgentLogs";
import { OnboardLinuxV2 } from "../../components/privilegedAccessManagement/endpoints/addEndpoint/OnboardLinuxV2";
import { OnboardWindowV2 } from "../../components/privilegedAccessManagement/endpoints/addEndpoint/OnboardWindowV2";
import { OnboardSshTarget } from "../../components/privilegedAccessManagement/endpoints/addEndpoint/OnboardSshTarget";
import ListRadiusDevices from "../../components/radius/listRadiusDevices";
// OLD: import OnboardRadiusDevices from "../../components/radius/onboardRadiusDevices";
import RadiusServersPage from "../../pages/enduser/radius-servers/RadiusServersPage";
import RadiusAuthLogs from "../../components/radius/RadiusAuthLogs";
import ProvidersDetails from "../../pages/identities/providers/ProvidersDetails";
import Step from "../../pages/identities/providers/Step";
import AddDirectory from "../../components/directory/activeDirectory/addDirectory";
import EndpointUsers from "../../components/privilegedAccessManagement/endpointsUsers/EndpointUsers";
import AddEndpointUser from "../../components/privilegedAccessManagement/endpointsUsers/AddEndpointUser";
import TenantSettings from "../../components/settings/settings";
import SettingsShell from "../../components/settings/SettingsShell";
import Appearance from "../../components/settings/Appearance";
import PlatformUsersPage from "../../pages/identities/PlatformUsersPage";
import TenantConfig from "../../components/windows/tenantConfig";
import LogsOutputConfig from "../../components/settings/logsConfig/logsConfig";
import LogsOutputConfigForm from "../../components/settings/logsConfig/logsConfigForm";
import RecordingStorage from "../../pages/enduser/settings/RecordingStorage";
import SsoProviders from "../../pages/enduser/settings/SsoProviders";
import Database from "../../components/database/dashboard";
import DBUsers from "../../components/database/users";
import UserPrivilegesScreen from "../../components/database/userPrivileges";
import OnboardWindowDatabase from "../../components/database/addWindowsDatabase";
import OnboardLinuxDatabase from "../../components/database/addLinuxDatabase";
import Apps from "../../components/AddApp/AppList";
import AddAppForm from "../../components/AddApp/AddAppForm";
import SecretsList from "../../components/secretsManagement/SecretsList";
import AddSecret from "../../components/secretsManagement/AddSecret";
import EndpointGroupDetails from "../../components/privilegedAccessManagement/endpointGroups/EndpointGroupDetails";
import EndpointGroups from "../../components/privilegedAccessManagement/endpointGroups/EndpointGroups";
import { Navigate } from "react-router-dom";
import EntraUsers from "../../components/directory/users/entraUsers";
import Users from "../../pages/identities/Users";
import Groups from "../../components/directory/groups/Groups";
import Logs from "../../components/authenticationPolicy/logs";
import AuthLogsIndex from "../../pages/enduser/AuthLogsIndex";
import AuthenticationPolicy from "../../components/authenticationPolicy/request/Request";
import CredentialRotationPolicy from "../../components/privilegedAccessManagement/endpointsUsers/CredentialRotationPolicy";
import ViewCredentials from "../../components/privilegedAccessManagement/endpointsUsers/ViewCredentials";
import CreatePolicyV3 from "../../components/authenticationPolicy/policies/CreatePolicyV3";
import CreatePolicyV4 from "../../components/authenticationPolicy/policies/CreatePolicyV4";
import PolicyList from "../../components/authenticationPolicy/policies/Policy";
import PoliciesListPage from "../../pages/policies/PoliciesListPage";
import PolicyEditorPage from "../../pages/policies/PolicyEditorPage";
import PolicyDetailPage from "../../pages/policies/PolicyDetailPage";
import { PoliciesIndexRedirect, legacyPolicyElement } from "../../pages/policies/legacyPolicyRoutes";
import AgentListScreen from "../../components/database/agent";
import DatabasesScreen from "../../components/database/databases";
import EndpointUserDetails from "../../components/privilegedAccessManagement/endpointsUsers/EndpointUserDetails";
import ConnectionsScreen from "../../components/database/screens/ConnectionsScreen";
import ApplicationsList from "../../pages/applications/ApplicationsList";
import ApplicationForm from "../../pages/applications/ApplicationForm";
import ApplicationPage from "../../pages/applications/ApplicationPage";
import SignInSource from "../../pages/applications/SignInSource";
import ApplicationsDashboard from "../../pages/applications/ApplicationsDashboard";

const pamRouter = [
    { path: "entraUsers", element: <EntraUsers /> },
    { path: "users", element: <Users /> },
    { path: "groups", element: <Groups /> },
    { path: "endpointuserDetails", element: <EndpointUserDetails /> },
    { path: "policy-request", element: <AuthenticationPolicy /> },
    { path: "policy-logs", element: <Logs /> },
    // My access is gone: connecting is the Connect button on each endpoint.
    // Old links (and anything under them) land on the endpoint list.
    { path: "myAccess/*", element: <Navigate to="/pam/endpoint" replace /> },
    // Follows the MFA mode: AD/RADIUS auth events, the SSH access log in PAM.
    { path: "auth-logs", element: <AuthLogsIndex /> },
    // Under jumpServer-… so PAM mode's allowedPathPrefixes ("/pam/jumpServer")
    // let it through; more specific than the /* below, so it wins.
    { path: "jumpServer-sessionRecordings/play/:id", element: <RecordingPlayerPage /> },
    { path: "jumpServer-sessionRecordings/*", element: <SessionRecordings /> },
    { path: "rotation/:instanceId/:epmUserId", element: <CredentialRotationPolicy /> },
    { path: "view-credentials/:instanceId/:epmUserId", element: <ViewCredentials /> },
    { path: "sessionRecordings/:id", element: <SessionRecordings /> },
    {
        path: "policy/*",
        children: [
            { path: "", element: <PolicyList /> },
            { path: "createEndpointAccessPolicy", element: <CreatePolicyV3 /> },
            { path: "createEndpointAccessPolicyV4", element: <CreatePolicyV4 /> },
            {
                path: "v2/*",
                children: [
                    // Old policy URLs. Each redirects to /pam/policies/<product>
                    // once that product's adapter exists, and renders the old
                    // screen until then (pages/policies/legacyPolicyRoutes.jsx).
                    { path: "", element: <PoliciesIndexRedirect /> },
                    { path: "create", element: legacyPolicyElement("/pam/policy/v2/create", null) },
                    { path: "createPolicy", element: legacyPolicyElement("/pam/policy/v2/createPolicy", null) },
                    { path: "createRadiusPolicy", element: legacyPolicyElement("/pam/policy/v2/createRadiusPolicy", null) },
                    { path: "edit/:policyId", element: legacyPolicyElement("/pam/policy/v2/edit/:policyId", null) },
                ],
            },
        ],
    },
    // The shared policy screens, one set for every product (spec 3).
    // :product is ad | ssh | radius | database | apps.
    { path: "policies/:product", element: <PoliciesListPage /> },
    { path: "policies/:product/new", element: <PolicyEditorPage /> },
    { path: "policies/:product/:policyId", element: <PolicyDetailPage /> },
    { path: "policies/:product/:policyId/edit", element: <PolicyEditorPage /> },
    {
        path: "ai/*",
        children: [
            { path: "logs", element: <LogsPageAI /> },
            { path: "troubleshoot", element: <TroubleshootReport /> },
        ],
    },
    {
        path: "jumpServer/*",
        children: [
            { path: "", element: <Jumpserver /> },
            // One-time setup only: register, install and trust the CA, verify.
            // Everything that outlives onboarding is on the gateway page below.
            { path: "onboard", element: <SshProxyOnboarding /> },
            // Fleet onboarding: enrolment tokens (?gateway=<id> pre-filters).
            { path: "enrol", element: <EnrolTokensPage /> },
            // Per-gateway settings — identity, policy, recording, log streaming
            // and this gateway's sessions. Everything the onboarding wizard used
            // to bury in steps 3-5, where it could only be reached by re-running
            // onboarding. Declared last; React Router ranks the static segments
            // above this one regardless.
            { path: ":jumpServerId", element: <GatewayDetail /> },
        ],
    },
    {
        path: "endpoint/*",
        children: [
            { path: "", element: <PAMEndpoint /> },
            { path: "endpointDetails", element: <EndpointDetails /> },
            { path: "passwordPolicies", element: <PasswordPolicies /> },
            { path: "agentLogs", element: <AgentLogs /> },
            {
                path: "addEndpoint/*",
                children: [
                    { path: "linux", element: <OnboardLinuxV2 /> },
                    { path: "windows", element: <OnboardWindowV2 /> },
                    { path: "ssh", element: <OnboardSshTarget /> }
                ],
            },
        ],
    },
    {
        path: "radius/*",
        children: [
            { path: "", element: <ListRadiusDevices /> },
            { path: "servers", element: <RadiusServersPage /> },
            // OLD: { path: "onboard", element: <OnboardRadiusDevices /> },
            // The Connect FreeRADIUS page became Add RADIUS server on RADIUS Servers.
            { path: "onboard/*", element: <Navigate to="/pam/radius/servers" replace /> },
            { path: "logs", element: <RadiusAuthLogs /> }
        ],
    },
    {
        path: "directory/*",
        children: [
            { path: "", element: <ProvidersDetails /> },
            { path: "addDirectory/step", element: <Step /> },
            { path: "addDirectory", element: <AddDirectory /> },
            // The agentless-mfa and mfa-users routes were removed: MFA
            // enable/disable is driven from policy (/pam/policy/v2) now.
        ],
    },
    {
        path: "endpointsUsers/*",
        children: [
            { path: "", element: <EndpointUsers /> },
            { path: "add", element: <AddEndpointUser /> },
        ],
    },
    // Targets → Password Rotation was removed: rotation is set per account on
    // Endpoint Users now. Old links (and its "add policy" children, linked from
    // onboarding and workload identity) land on the endpoint list.
    { path: "credentialRotation/*", element: <Navigate to="/pam/endpoint" replace /> },
    // The old privilege elevation page: sudo grants live on Endpoint Users.
    { path: "elevation/*", element: <Navigate to="/pam/endpointsUsers" replace /> },
    {
        // Browser-style settings: its own menu on the left, the page on the right.
        path: "settings/*",
        element: <SettingsShell />,
        children: [
            { path: "", element: <TenantSettings /> },
            { path: "mfaProvider", element: <TenantSettings section="mfa" /> },
            // The Authenticator's settings live inside MFA Provider now.
            { path: "authenticator", element: <Navigate to="/pam/settings/mfaProvider" replace /> },
            { path: "users", element: <PlatformUsersPage /> },
            { path: "mfa", element: <Navigate to="/pam/settings/tenantConfig?panel=userMfa" replace /> },
            { path: "tenantConfig", element: <TenantConfig /> },
            { path: "recordingStorage", element: <RecordingStorage /> },
            { path: "sso", element: <SsoProviders /> },
            { path: "appearance", element: <Appearance /> },
            {   
                path: "logsConfig/*", children: [
                    { path: "", element: <LogsOutputConfig /> },
                    { path: "output", element: <LogsOutputConfigForm /> },
                ] 
            }
        ],
    },
    {
        path: "databases/*",
        children: [
            { path: "", element: <DatabasesScreen /> },
            { path: "dashboard", element: <Database /> },
            { path: "agents", element: <AgentListScreen /> },
            { path: "users", element: <DBUsers /> },
            { path: "userPrivileges", element: <UserPrivilegesScreen /> },
            { path: "connections", element: <ConnectionsScreen /> },
            {   
                path: "add/*", children: [
                    { path: "windows", element: <OnboardWindowDatabase /> },
                    { path: "linux", element: <OnboardLinuxDatabase /> },
                ] 
            }
        ],
    },
    {
        path: "apps/*",
        children: [
            { path: "", element: <Apps /> },
            { path: "add", element: <AddAppForm /> }
        ],
    },
    {
        // The Applications product (mode mfa_apps): AuthNull as the identity
        // provider for the tenant's own apps. Not the legacy apps/* above.
        path: "applications/*",
        children: [
            { path: "", element: <ApplicationsList /> },
            { path: "dashboard", element: <ApplicationsDashboard /> },
            { path: "new", element: <ApplicationForm /> },
            { path: "signInSource", element: <SignInSource /> },
            // Redirects to /pam/policies/apps/... (the apps policy adapter is live).
            { path: "policies", element: legacyPolicyElement("/pam/applications/policies", null) },
            { path: "policies/new", element: legacyPolicyElement("/pam/applications/policies/new", null) },
            { path: "policies/:policyId", element: legacyPolicyElement("/pam/applications/policies/:policyId", null) },
            { path: ":id", element: <ApplicationPage /> }
        ],
    },
    {
        path: "secrets/*",
        children: [
            { path: "", element: <SecretsList /> },
            { path: "add", element: <AddSecret /> }
        ],
    },
    {
        path: "endpointGroups/*",
        children: [
            { path: "", element: <EndpointGroups /> },
            { path: "endpointGroupDetails", element: <EndpointGroupDetails /> }
        ],
    },
    
];

export default pamRouter;
